import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ArrowLeft, Home, Sun, Moon } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';
import './Layout.css';

const Layout = ({ children, title, onBack }) => {
    const history = useHistory();
    const location = useLocation();
    const { theme, toggleTheme } = useTheme();
    const isHome = location.pathname === '/';

    // Generate random stars for the background
    const stars = useMemo(() => {
        return Array.from({ length: 50 }).map((_, i) => ({
            id: i,
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            size: `${Math.random() * 3 + 1}px`,
            duration: `${Math.random() * 3 + 2}s`,
            delay: `${Math.random() * 5}s`
        }));
    }, []);

    return (
        <div className="layout-container">
            <div className="stars-bg">
                {stars.map(star => (
                    <div
                        key={star.id}
                        className="star"
                        style={{
                            left: star.left,
                            top: star.top,
                            width: star.size,
                            height: star.size,
                            '--duration': star.duration,
                            animationDelay: star.delay
                        }}
                    />
                ))}
            </div>

            <header className="app-header">
                <div className="header-left">
                    {!isHome && (
                        <button className="nav-button back-button" onClick={onBack || (() => history.goBack())}>
                            <ArrowLeft size={32} />
                        </button>
                    )}
                    <div className="logo-container" onClick={() => history.push('/')}>
                        <img src="/logo.png" alt="Early Learning Logo" className="app-logo" />
                    </div>
                </div>
                <h1 className="page-title">{title || 'Early Learning'}</h1>
                <div className="header-right">
                    {!isHome && (
                        <button className="nav-button home-button" onClick={() => history.push('/')}>
                            <Home size={32} />
                        </button>
                    )}
                </div>
            </header>
            <main className="app-content">
                {children}
            </main>
            <footer className="app-footer">
                <p>Created with ❤️ for little learners</p>
                {isHome && (
                    <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle Theme">
                        {theme === 'light' ? <Moon size={24} /> : <Sun size={24} />}
                        <span>{theme === 'light' ? 'Go to Night Time' : 'Back to Day Time'}</span>
                    </button>
                )}
                <p className="copyright">© 2026 Early Learning. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default Layout;
